import styled from "styled-components";
import React, { ReactNode } from 'react';

const SpecialTitleContainer = styled.div`
    position: relative;
    cursor: pointer;
    padding-bottom: 2vh;
    width: 100%;
`;

const Foreground = styled.a`
    font-family: "Ubuntu", sans-serif;
    font-weight: 700;
    font-size: calc(5vw + 8vh);
    background-image: 
        linear-gradient(180deg,
        #5bcffa 42%,#f5abb9 42%, #f5abb9 51%, #ffffff 51%, #ffffff 63.8%,  #f5abb9 63.8%, #f5abb9 75%, #5bcffa 75%);
    color: transparent;
    -webkit-background-clip: text;
    background-clip: text;
    position: absolute;
    margin: 0;
    top: 0;
    width: 100%;
    text-align: center;
    z-index: 3;
    text-decoration: underline #5bcffa;
`;

const Shadow = styled.h1`
    font-family: "Ubuntu", sans-serif;
    font-weight: 700;
    font-size: calc(5vw + 8vh);
    color: transparent;
    text-shadow: calc(.1vw + .1vh) calc(.1vw + .1vh) calc(.05vw + .05vh) black;
    user-select: none;
    margin: 0px;
    text-align: center;
    position: relative;
    z-index: 2;
`;

const SpecialTitle = (props: {children: ReactNode}) => {
    return <SpecialTitleContainer>
            <Shadow>{props.children}</Shadow>
            <Foreground href="https://www.hrc.org/resources/seven-things-about-transgender-people-that-you-didnt-know">{props.children}</Foreground>
        </SpecialTitleContainer>;
};

export default SpecialTitle;